import { app } from '../../../../../app';
import { Controller } from './manage-passwords.controller';

app.component('companyManageApplicationUsersManagePasswords', {
    bindings: {
        groupId: '<',
        application: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./manage-passwords.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/manage-passwords/manage-passwords.component.js